module.exports = __webpack_public_path__ + "static/media/16_after.5999d468.jpg";